module.exports = __webpack_public_path__ + "media/images/cursors/arrow_left-e6cef3312af26a38cc2233f31f8c685a.svg";